export function getDefaultOptions() {
    return {
        accordionButtonsSelector: `.accordion-button`,
        enableKeyboardSupport: true,
    }
}

export function initialize(_options = getDefaultOptions()) {
    console.log("Initializing accordion buttons.");

    const options = _options;

    document.querySelectorAll(options.accordionButtonsSelector).forEach(abtn => {
        abtn.addEventListener(`click`, e => {
            const expanded = abtn.getAttribute(`aria-expanded`) === `true`;
            const panel = document.getElementById(abtn.getAttribute(`aria-controls`));

            abtn.setAttribute(`aria-expanded`, !expanded);
            panel.setAttribute(`aria-hidden`, expanded);
        });

        if (options.enableKeyboardSupport)  {
            abtn.addEventListener(`keydown`, e => {
                const currentIdx = [...accordionButtons].indexOf(abtn);

                switch (e.key) {
                    case `Home`:
                        e.preventDefault();
                        accordionButtons[0].focus();
                        break;
                    case `End`:
                        e.preventDefault();
                        accordionButtons[accordionButtons.length - 1].focus();
                        break;
                }
            });
        }
    });

    console.log("Accordion buttons initialized.");
}